import moment from "moment";
import { useAppSelector } from "../../config/hooks";

const useAttendanceCalendar=()=>{
  const attendance = useAppSelector((state)=>state.attendance.attendanceList);
  const holidayList = useAppSelector((state)=>state.appConfig.holidayList)
  const employeeWorking=(date)=>{
    let working = attendance.find((t)=>moment(t.date).format("YYYY/MM/DD") == date) 
    return working;
  }
  const getHoliday=(date)=>{
    let holiday = holidayList.find((h)=>moment(h.Date).format("YYYY/MM/DD") == date)
    return holiday;
  }
  return{getHoliday,employeeWorking};

}
//"Date": "2025-02-26",

export default useAttendanceCalendar;